import styled from 'styled-components';
import tw from 'twin.macro';

const Section = styled.section`
    ${tw`py-12 sm:py-24 sm:px-10 px-8 max-w-screen-xl mx-auto`}
`;

export { Section };
